// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zGoC","name":"styles_name__PmsTl","phone":"styles_phone__3dXwL"};